<template>
    <v-card-text>
        <v-row dense align="center" class="mb-2">
            <v-col cols="12" md="5">
                <div class="text-body-2 grey--text text--darken-1">
                    Avisos que aparecen en la campana de notificaciones de los usuarios. Se muestran los enviados desde aquí y los
                    avisos a administradores que genera el sistema; los avisos individuales por certificado no se listan.
                </div>
            </v-col>
            <v-col cols="12" sm="7" md="4">
                <v-text-field v-model="busqueda" hide-details dense outlined clearable prepend-inner-icon="search" label="Buscar"/>
            </v-col>
            <v-col cols="12" sm="5" md="3" class="text-sm-right">
                <v-btn color="info" small outlined class="mr-2" :loading="cargando" @click="cargar"><v-icon small>refresh</v-icon></v-btn>
                <v-btn color="success" small outlined v-if="permisos.crear" @click="nuevo"><v-icon small left>add</v-icon> Nuevo mensaje</v-btn>
            </v-col>
        </v-row>

        <v-data-table
            dense
            :headers="encabezados"
            :items="filas"
            :search="busqueda"
            :loading="cargando"
            item-key="notificacion_id"
            :items-per-page="15"
            :footer-props="$store.state.footerPropsTable"
        >
            <template v-slot:[`item.fecha_crea`]="{ item }">
                {{ item.fecha_crea | fechaESPHora }}
                <div class="text-caption grey--text" v-if="item.creado_por">por {{ item.creado_por }}</div>
                <div class="text-caption grey--text" v-else-if="item.automatica">generado por el sistema</div>
            </template>
            <template v-slot:[`item.destino`]="{ item }">
                <v-chip x-small label :color="colorDestino(item.destino)" text-color="white">{{ textoDestino(item.destino) }}</v-chip>
                <div class="text-caption" v-if="item.destino === 'persona'">{{ item.persona || ('Persona ' + item.persona_id) }}</div>
            </template>
            <template v-slot:[`item.titulo`]="{ item }">
                <div class="d-flex align-center">
                    <v-icon small class="mr-1" :color="colorTipo(item.tipo)">{{ iconoTipo(item.tipo) }}</v-icon>
                    <span class="font-weight-medium">{{ item.titulo }}</span>
                </div>
                <div class="text-caption grey--text text--darken-1 text-truncate" style="max-width: 420px" :title="item.mensaje">{{ item.mensaje }}</div>
                <a v-if="item.enlace" class="text-caption" :href="item.enlace" target="_blank" rel="noopener">{{ item.enlace }}</a>
            </template>
            <template v-slot:[`item.leidas`]="{ item }">
                {{ item.leidas }}
            </template>
            <template v-slot:[`item.expira_en`]="{ item }">
                <span v-if="!item.expira_en" class="grey--text">No expira</span>
                <v-chip v-else x-small label :color="item.expirada ? 'grey' : 'blue-grey'" text-color="white">
                    {{ item.expirada ? 'Expiró ' : '' }}{{ item.expira_en | fechaESPHora }}
                </v-chip>
            </template>
            <template v-slot:[`item.acciones`]="{ item }">
                <v-btn icon small color="error" v-if="permisos.eliminar" title="Eliminar" @click="confirmarEliminar(item)"><v-icon small>delete</v-icon></v-btn>
            </template>
            <template v-slot:no-data>
                <v-alert dense type="info" outlined class="text-center mt-3">
                    Aún no se han enviado mensajes. {{ permisos.crear ? 'Use el botón Nuevo mensaje.' : '' }}
                </v-alert>
            </template>
        </v-data-table>

        <!-- Nuevo mensaje -->
        <v-dialog v-model="dialogo" max-width="720" persistent scrollable>
            <v-card>
                <v-card-title class="text-subtitle-1 font-weight-bold">
                    Nuevo mensaje
                    <v-spacer></v-spacer>
                    <v-btn icon small @click="dialogo = false"><v-icon>close</v-icon></v-btn>
                </v-card-title>
                <v-card-text>
                    <v-form ref="form" v-model="valido" @submit.prevent="guardar">
                        <v-row dense>
                            <v-col cols="12" md="6">
                                <v-select v-model="modelo.destino" :items="opcionesDestino" label="Destino" outlined dense :rules="[reglas.requerido]"/>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-select v-model="modelo.tipo" :items="opcionesTipo" label="Tipo" outlined dense :rules="[reglas.requerido]">
                                    <template v-slot:item="{ item }"><v-icon small left :color="colorTipo(item.value)">{{ iconoTipo(item.value) }}</v-icon>{{ item.text }}</template>
                                </v-select>
                            </v-col>
                            <v-col cols="12" v-if="modelo.destino === 'persona'">
                                <v-autocomplete
                                    v-model="modelo.persona_id"
                                    :items="personas"
                                    :loading="buscandoPersonas"
                                    :search-input.sync="busquedaPersona"
                                    item-value="persona_id"
                                    :item-text="p => `${p.nombre} ${p.apellido} (${p.numero_identidad || 'sin identidad'})`"
                                    label="Participante"
                                    hint="Escriba el nombre o el número de identidad"
                                    persistent-hint
                                    outlined dense clearable no-filter
                                    prepend-inner-icon="person_search"
                                    no-data-text="Escriba al menos 3 caracteres para buscar"
                                    :rules="[reglas.requerido]"
                                />
                            </v-col>
                            <v-col cols="12">
                                <v-text-field v-model="modelo.titulo" label="Título" outlined dense maxlength="150" counter="150" :rules="[reglas.requerido]"/>
                            </v-col>
                            <v-col cols="12">
                                <v-textarea v-model="modelo.mensaje" label="Mensaje" outlined dense rows="4" auto-grow maxlength="2000" counter="2000" :rules="[reglas.requerido]"/>
                            </v-col>
                            <v-col cols="12" md="7">
                                <v-text-field v-model="modelo.enlace" label="Enlace (opcional)" outlined dense maxlength="300" placeholder="/mis_cursos/historial"
                                              hint="Ruta del sistema o dirección https://" persistent-hint :rules="[reglas.enlace]"/>
                            </v-col>
                            <v-col cols="12" md="5">
                                <v-text-field v-model="modelo.expira_en" label="Expira (opcional)" type="datetime-local" outlined dense
                                              hint="Después de esta fecha deja de mostrarse" persistent-hint :rules="[reglas.futura]"/>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions class="px-6 pb-4">
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogo = false">Cancelar</v-btn>
                    <v-btn color="primary" depressed :loading="guardando" @click="guardar"><v-icon small left>send</v-icon> Enviar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogoEliminar" max-width="420">
            <v-card>
                <v-card-title class="text-subtitle-1 font-weight-bold">Eliminar mensaje</v-card-title>
                <v-card-text>
                    ¿Eliminar <b>{{ aEliminar ? aEliminar.titulo : '' }}</b>? Dejará de verse en la campana de todos los destinatarios.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogoEliminar = false">Cancelar</v-btn>
                    <v-btn color="error" depressed :loading="guardando" @click="eliminar">Eliminar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card-text>
</template>

<script>
const DESTINOS = {todos: "Todos", estudiantes: "Participantes", administradores: "Administradores", persona: "Una persona"};
const COLOR_DESTINO = {todos: "primary", estudiantes: "teal", administradores: "deep-purple", persona: "blue-grey"};
const TIPOS = {mensaje: "Mensaje", certificado: "Certificado", sistema: "Sistema"};
const ICONO_TIPO = {mensaje: "campaign", certificado: "workspace_premium", sistema: "settings"};
const COLOR_TIPO = {mensaje: "primary", certificado: "#D29E4A", sistema: "grey darken-1"};

/** Pestaña Mensajes: crear notificaciones manuales y ver las enviadas. */
export default {
    name: "NotificacionesMensajes",
    data() {
        return {
            cargando: false,
            guardando: false,
            busqueda: "",
            filas: [],
            permisos: {crear: false, editar: false, eliminar: false},
            dialogo: false,
            dialogoEliminar: false,
            valido: true,
            modelo: this.vacio(),
            aEliminar: null,
            personas: [],
            busquedaPersona: null,
            buscandoPersonas: false,
            temporizadorBusqueda: null,
            opcionesDestino: Object.keys(DESTINOS).map(v => ({text: DESTINOS[v], value: v})),
            opcionesTipo: Object.keys(TIPOS).map(v => ({text: TIPOS[v], value: v})),
            encabezados: [
                {text: "Enviado", value: "fecha_crea"},
                {text: "Destino", value: "destino"},
                {text: "Mensaje", value: "titulo"},
                {text: "Leídas", value: "leidas", align: "end"},
                {text: "Expira", value: "expira_en"},
                {text: "", value: "acciones", sortable: false, align: "end"},
            ],
            reglas: {
                requerido: v => (v !== null && v !== undefined && String(v).trim() !== "") || "Campo requerido",
                enlace: v => !v || /^(\/\S*|https?:\/\/\S+)$/i.test(String(v).trim()) || "Ruta del sistema (/...) o dirección https://",
                futura: v => !v || new Date(v).getTime() > Date.now() || "Debe ser una fecha futura",
            },
        }
    },
    watch: {
        busquedaPersona(texto) {
            clearTimeout(this.temporizadorBusqueda);
            if (!texto || texto.trim().length < 3) return;
            this.temporizadorBusqueda = setTimeout(() => this.buscarPersonas(texto.trim()), 350);
        },
        "modelo.destino"(destino) {
            if (destino !== "persona") this.modelo.persona_id = null;
        },
    },
    methods: {
        textoDestino(d) {
            return DESTINOS[d] || d;
        },
        colorDestino(d) {
            return COLOR_DESTINO[d] || "grey";
        },
        iconoTipo(t) {
            return ICONO_TIPO[t] || "notifications";
        },
        colorTipo(t) {
            return COLOR_TIPO[t] || "grey";
        },
        vacio() {
            return {destino: "todos", tipo: "mensaje", persona_id: null, titulo: "", mensaje: "", enlace: "", expira_en: ""};
        },
        cargar() {
            this.cargando = true;
            window.axios.get("/notificaciones/mensajes").then(response => {
                if (response.data.success) {
                    this.filas = response.data.data.filas;
                    this.permisos = response.data.data.permisos;
                } else {
                    this.$toast.error(response.data.message);
                }
            })
                .catch(() => this.$toast.error("No se pudieron cargar los mensajes."))
                .finally(() => {
                    this.cargando = false;
                });
        },
        buscarPersonas(texto) {
            this.buscandoPersonas = true;
            const campo = /^\d+$/.test(texto) ? "identidad" : "nombre";
            window.axios.get("/personas/search", {params: {busqueda: texto, campo, cat_tipo_persona_id: 3}}).then(response => {
                if (response.data.success) {
                    this.personas = response.data.data;
                }
            })
                .catch(() => {})
                .finally(() => {
                    this.buscandoPersonas = false;
                });
        },
        nuevo() {
            this.modelo = this.vacio();
            this.personas = [];
            this.dialogo = true;
            this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation());
        },
        guardar() {
            if (!this.$refs.form.validate()) return;

            this.guardando = true;
            const datos = {
                destino: this.modelo.destino,
                tipo: this.modelo.tipo,
                persona_id: this.modelo.destino === "persona" ? this.modelo.persona_id : null,
                titulo: this.modelo.titulo.trim(),
                mensaje: this.modelo.mensaje.trim(),
                enlace: (this.modelo.enlace || "").trim() || null,
                expira_en: this.modelo.expira_en ? this.modelo.expira_en.replace("T", " ") : null,
            };

            window.axios.post("/notificaciones/mensajes", datos).then(response => {
                if (response.data.success) {
                    this.$toast.success(response.data.message, {timeout: 8000});
                    this.dialogo = false;
                    this.cargar();
                    this.$root.$emit("notificaciones-actualizar");
                } else {
                    this.$toast.error(response.data.message, {timeout: 8000});
                }
            })
                .catch(error => this.$toast.error(this.mensajeError(error, "No se pudo enviar el mensaje."), {timeout: 8000}))
                .finally(() => {
                    this.guardando = false;
                });
        },
        confirmarEliminar(fila) {
            this.aEliminar = fila;
            this.dialogoEliminar = true;
        },
        eliminar() {
            this.guardando = true;
            window.axios.post("/notificaciones/mensajes/eliminar", {notificacion_id: this.aEliminar.notificacion_id}).then(response => {
                if (response.data.success) {
                    this.$toast.success(response.data.message);
                    this.dialogoEliminar = false;
                    this.cargar();
                    this.$root.$emit("notificaciones-actualizar");
                } else {
                    this.$toast.error(response.data.message, {timeout: 8000});
                }
            })
                .catch(error => this.$toast.error(this.mensajeError(error, "No se pudo eliminar el mensaje."), {timeout: 8000}))
                .finally(() => {
                    this.guardando = false;
                });
        },
        mensajeError(error, defecto) {
            return (error.response && error.response.data && error.response.data.message) || defecto;
        },
    },
    created() {
        this.cargar();
    },
}
</script>
